import { render } from "./IssueProgressCard.vue?vue&type=template&id=39fecfbc&scoped=true"
import script from "./IssueProgressCard.vue?vue&type=script&lang=js"
export * from "./IssueProgressCard.vue?vue&type=script&lang=js"

import "./IssueProgressCard.vue?vue&type=style&index=0&id=39fecfbc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-39fecfbc"

export default script